import React, { useState } from 'react';
import '../../css/FAQs.css';

const FAQIAATs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What is the Iowa Algebra Aptitude Test (IAAT)?",
      answer: "The Iowa Algebra Aptitude Test (IAAT) is a standardized assessment designed to evaluate a student's readiness for Algebra I. The test helps determine whether students have the essential mathematical foundation and skills needed to succeed in Algebra I, typically administered to 6th-grade students to assess their readiness for 7th-grade Algebra I."
    },
    {
      question: "Why is the IAAT test important for students?",
      answer: "The IAAT test is important because it helps identify students who are ready for Algebra I and those who may need additional preparation. Many school districts use IAAT scores to make placement decisions, ensuring students enter Algebra I when they have the necessary foundational skills. Early identification helps prevent struggles and sets students up for success in advanced mathematics."
    },
    {
      question: "How can my child prepare for the IAAT test?",
      answer: "The best way to prepare for IAAT is through regular practice with sample questions from all four key areas (Pre-Algebraic Number Skills, Interpreting Mathematical Information, Representing Relationships, and Using Symbols). Focus on strengthening basic math skills, pattern recognition, and algebraic thinking. Our free practice platform offers thousands of IAAT sample questions with detailed explanations to help students build confidence and improve their performance."
    },
    {
      question: "What grade levels take the IAAT test?",
      answer: "The IAAT test is typically administered to 6th-grade students to determine their readiness for Algebra I in 7th grade. However, some school districts may also use it for other grade levels depending on their math placement policies. The test is designed to assess readiness rather than achievement, making it suitable for students at the transition point between elementary and middle school mathematics."
    },
    {
      question: "What types of questions are on the IAAT test?",
      answer: "The IAAT test includes multiple-choice questions across four key areas: Pre-Algebraic Number Skills (fractions, decimals, basic operations), Interpreting Mathematical Information (graphs, charts, word problems), Representing Relationships (patterns, sequences, numerical relationships), and Using Symbols (algebraic notation, equations, order of operations). All questions are designed to assess readiness for algebraic thinking."
    },
    {
      question: "How long does the IAAT test take?",
      answer: "The IAAT test typically takes 50-60 minutes to complete, making it efficient enough to be administered in a single class period. The test is designed to be completed in one sitting, allowing schools to efficiently assess multiple students while minimizing disruption to the school day."
    },
    {
      question: "How is the IAAT test scored?",
      answer: "IAAT scores are centrally processed for accuracy and consistency. Results typically include raw scores, percentile rankings, and readiness indicators. Higher scores indicate stronger readiness for Algebra I. Many school districts use specific score thresholds to determine placement, with students scoring above the threshold being recommended for Algebra I and others receiving additional preparation support."
    },
    {
      question: "Can students practice for the IAAT test online?",
      answer: "Yes! Students can practice for the IAAT test using online practice platforms like SmartKids Prep, which offers free access to thousands of IAAT sample questions. Online practice helps students become familiar with the question formats, timing, and types of mathematical reasoning required. Practice tests are available for all four key areas with detailed explanations for each answer, helping students understand the reasoning behind correct solutions."
    }
  ];

  return (
    <section className="iaat-faq-section" aria-label="IAAT Frequently Asked Questions">
      <div className="iaat-faq-wrapper">
        <h2 className="iaat-faq-title">
          Frequently Asked Questions About IAAT
        </h2>
        <p className="iaat-faq-intro">
          Find answers to common questions about the Iowa Algebra Aptitude Test (IAAT), test preparation, scoring, and more.
        </p>
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <div
                className="faq-question"
                onClick={() => toggleQuestion(index)}
                style={{ cursor: 'pointer' }}
              >
                {faq.question}
                <span className={`faq-toggle-icon ${openIndex === index ? 'open' : ''}`}>
                  {openIndex === index ? '-' : '+'}
                </span>
              </div>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQIAATs;
